const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || "";
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || "";
const envFlag = (value, fallback = "") => String(value ?? fallback).trim().toLowerCase();
const freeLaunchMode = envFlag(import.meta.env.VITE_FREE_LAUNCH_MODE, "false") === "true";
const emailsEnabled =
  envFlag(import.meta.env.VITE_EMAILS_ENABLED) === "true";
const paymentsEnabled =
  !freeLaunchMode &&
  envFlag(import.meta.env.VITE_PAYMENTS_ENABLED) === "true";
const giftFundEnabled =
  paymentsEnabled &&
  envFlag(import.meta.env.VITE_GIFT_FUND_ENABLED, "true") !== "false";
const googleAuthEnabled =
  envFlag(import.meta.env.VITE_GOOGLE_AUTH_ENABLED) === "true";
const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL || "aevolive@gmail.com";
const adminEmails = Array.from(
  new Set(
    [
      ...String(import.meta.env.VITE_ADMIN_EMAILS || "").split(","),
      supportEmail,
      "aevolive@gmail.com",
    ]
      .map((email) => String(email || "").trim().toLowerCase())
      .filter(Boolean)
  )
);

export const runtimeConfig = {
  appName: import.meta.env.VITE_APP_NAME || "Aevo",
  siteUrl: import.meta.env.VITE_SITE_URL || "https://aevo.live",
  supportEmail,
  adminEmails,
  supabaseUrl,
  supabaseAnonKey,
  supabaseStorageBucket: import.meta.env.VITE_SUPABASE_STORAGE_BUCKET || "event-media",
  supabaseFunctionsUrl:
    import.meta.env.VITE_SUPABASE_FUNCTIONS_URL ||
    (supabaseUrl ? `${supabaseUrl}/functions/v1` : ""),
  guestGalleryFunctionName:
    import.meta.env.VITE_GUEST_GALLERY_FUNCTION_NAME || "public_guest_gallery",
  joinEventFunctionName:
    import.meta.env.VITE_JOIN_EVENT_FUNCTION_NAME || "join_event_by_code",
  createEventFunctionName:
    import.meta.env.VITE_CREATE_EVENT_FUNCTION_NAME || "create_event",
  createEventCheckoutFunctionName:
    import.meta.env.VITE_CREATE_EVENT_CHECKOUT_FUNCTION_NAME || "create_event_checkout",
  createSupportTicketFunctionName:
    import.meta.env.VITE_CREATE_SUPPORT_TICKET_FUNCTION_NAME || "create_support_ticket",
  startGiftFundCheckoutFunctionName:
    import.meta.env.VITE_START_GIFT_FUND_CHECKOUT_FUNCTION_NAME || "start_gift_fund_checkout",
  transferGiftFundDonationsFunctionName:
    import.meta.env.VITE_TRANSFER_GIFT_FUND_DONATIONS_FUNCTION_NAME || "transfer_gift_fund_donations",
  startConnectOnboardingFunctionName:
    import.meta.env.VITE_START_CONNECT_ONBOARDING_FUNCTION_NAME || "start_connect_onboarding",
  refreshConnectAccountFunctionName:
    import.meta.env.VITE_REFRESH_CONNECT_ACCOUNT_FUNCTION_NAME || "refresh_connect_account",
  manageNotificationsFunctionName:
    import.meta.env.VITE_MANAGE_NOTIFICATIONS_FUNCTION_NAME || "manage_notifications",
  manageMomentsFunctionName:
    import.meta.env.VITE_MANAGE_MOMENTS_FUNCTION_NAME || "manage_moments",
  uploadPhotoFunctionName:
    import.meta.env.VITE_UPLOAD_PHOTO_FUNCTION_NAME || "upload_photo",
  createGuestUploadFunctionName:
    import.meta.env.VITE_CREATE_GUEST_UPLOAD_FUNCTION_NAME || "create_guest_upload_url",
  moderateAndPublishPhotoFunctionName:
    import.meta.env.VITE_MODERATE_PHOTO_FUNCTION_NAME || "moderate_and_publish_photo",
  manualModeratePhotoFunctionName:
    import.meta.env.VITE_MANUAL_MODERATE_PHOTO_FUNCTION_NAME || "moderate_photo",
  deletePhotoFunctionName:
    import.meta.env.VITE_DELETE_PHOTO_FUNCTION_NAME || "delete_photo",
  deleteAccountFunctionName:
    import.meta.env.VITE_DELETE_ACCOUNT_FUNCTION_NAME || "delete_account",
  deleteEventPhotosFunctionName:
    import.meta.env.VITE_DELETE_EVENT_PHOTOS_FUNCTION_NAME || "delete_event_photos",
  adminFunctionName:
    import.meta.env.VITE_ADMIN_FUNCTION_NAME || "admin_console",
  welcomeEmailFunctionName:
    import.meta.env.VITE_WELCOME_EMAIL_FUNCTION_NAME || "send_welcome_email",
  allowInsecureDirectGuestRead:
    envFlag(import.meta.env.VITE_ALLOW_INSECURE_DIRECT_GUEST_READ) === "true",
  imageTransformsEnabled:
    envFlag(import.meta.env.VITE_IMAGE_TRANSFORMS_ENABLED) === "true",
  posthogHost: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
  freeLaunchMode,
  emailsEnabled,
  paymentsEnabled,
  giftFundEnabled,
  googleAuthEnabled,
  enabledPlans: freeLaunchMode ? ["free"] : ["free", "standard", "plus", "premium"],
};

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);
